import React from 'react'
import { IPropsTickets, ISellCreditTicket } from '../utils/interfaceTickets'

const InfoClientTicket = ({ data }: IPropsTickets) => {

    let newData = data as ISellCreditTicket

    return (
        <>
            <table>
                <thead>
                    <tr>
                        <th className="receipt__table__header" style={{ width: '50%' }}></th>
                        <th className="receipt__table__header" style={{ width: '50%' }}></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="receipt__table__cell">CLIENTE</td>
                        <td className="receipt__table__cell text__ellipsis w__ellipsis__medium">{newData.nombre_cliente}</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell">IDENTIFICACION</td>
                        <td className="receipt__table__cell">{newData.numero_documento_cliente}</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell">SERIAL</td>
                        <td className="receipt__table__cell">{newData.serial_medio_autorizacion}</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell">MEDIO</td>
                        <td className="receipt__table__cell">{newData.medio_autorizacion}</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell">PLACA</td>
                        <td className="receipt__table__cell">{newData.placa}</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell">CONDUCTOR</td>
                        <td className="receipt__table__cell">{newData?.conductor?.conductor}</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell">T. IDENTIFICADOR</td>
                        <td className="receipt__table__cell">{newData?.conductor?.abreviatura}</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell">N. IDENTIFICADOR</td>
                        <td className="receipt__table__cell">{newData?.conductor?.identificacion}</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell">N. INTERNA</td>
                        <td className="receipt__table__cell">{newData?.n_interna}</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell">KILOMETRAJE</td>
                        <td className="receipt__table__cell">{newData?.kilometraje}</td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default InfoClientTicket